export default {"src":"/_next/static/media/endeavor-promessas-logo-87-18.f35424a8.svg","height":18,"width":87};